export const CompanyClassificationTypeEnum = {
  ISIC: 'ISIC',
  NACE: 'NACE',
  NAF: 'NAF',
  SIC: 'SIC',
  SIC_UK: 'SIC_UK',
} as const;
export type CompanyClassificationTypeEnum =
  (typeof CompanyClassificationTypeEnum)[keyof typeof CompanyClassificationTypeEnum];
